/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticlePaywall/SuccessfulPayment/theme';

export const ArticlePaywallSuccessfulPaymentTheme = theme;
